module.exports = __webpack_public_path__ + "img/4-4.fc206ec6.jpg";